import type { AxiosResponse } from 'axios';
import React from 'react';
import { getAccessToken } from '../../api/auth/auth.api';
import {
  cacheStaffLoginTokens,
  isDeviceRemembered,
  retrieveStaffAuthTokens,
} from '../../utils/next/auth.utils';

interface UseRememberDeviceParams {
  onSuccess?: () => void;
  onFailure?: () => void;
}

export const useRememberDevice = ({
  onSuccess,
  onFailure,
}: UseRememberDeviceParams) => {
  const isRemembered = isDeviceRemembered();
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (!isRemembered) {
      setIsLoading(false);
    } else {
      // Remember-device login is a staff login: it reads the staff token, never a flow session's.
      const { refreshToken } = retrieveStaffAuthTokens();
      getAccessToken({ data: { refreshToken } })
        .then((resp: AxiosResponse) => {
          cacheStaffLoginTokens(resp.data.accessToken, String(refreshToken));

          if (typeof onSuccess === 'function') {
            onSuccess();
          }
        })
        .catch(() => {
          if (typeof onFailure === 'function') {
            onFailure();
          }
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  return { isRemembered, isLoading };
};
